import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// Main components
import MainLayout from "../../../components/main/layout/layout";
// Maintenance components
import MaintenanceView from "../../../components/maintenance/view/view";
// Actions
import * as mainActions from "../../../redux/actions/main";
import * as usersActions from "../../../redux/actions/users";
// Styles
import "./view.css";

const UsersView = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [refreshData, setRefreshData] = useState(false);
  // Selectors
  const currentPage = useSelector((state) => state.mainReducer.currentPage);

  // Set consts and vars
  const page = "users";

  useEffect(() => {
    if (!!currentPage) return;
    // Set active page
    dispatch(mainActions.setCurrentPage(page));
  }, []);

  // Set grid config
  const filters = [`email`, `name`, `fullname`, `access_levels`];
  const sorters = [`email`, `name`, `fullname`, `access_levels`];
  const columns = [
    { 
      name: "email",
      width: `400px`,
      header: {
        dataType: "string",
        placeholder: "Email",
        textAlign: "left",
      },
      style: {
        textAlign: "left",
        overflow: "hidden",         // Oculta el contenido que sobresale
        textOverflow: "ellipsis",   // Muestra "..." si el texto es demasiado largo
        whiteSpace: "nowrap",       // Impide que el texto se divida en varias líneas
      }
    },
    { 
      name: "name",
      width: `220px`,
      header: {
        dataType: "string",
        placeholder: "Nom",
        textAlign: "left",
      },
      style: {
        textAlign: "left",       // Alinea el texto a la izquierda
        overflow: "hidden",      // Oculta cualquier desbordamiento fuera de la celda
        textOverflow: "clip",    // Desactiva los tres puntos (opcional)
        whiteSpace: "normal",    // Permite que el texto se ajuste en varias líneas
        wordBreak: "break-word", // Asegura que las palabras largas se corten si es necesario
      }
    },
    { 
      name: "fullname",
      header: {
        dataType: "string",
        placeholder: "Nom complet",
        textAlign: "left",
      },
      style: {
        textAlign: "left",       // Alinea el texto a la izquierda
        overflow: "hidden",      // Oculta cualquier desbordamiento fuera de la celda
        textOverflow: "clip",    // Desactiva los tres puntos (opcional)
        whiteSpace: "normal",    // Permite que el texto se ajuste en varias líneas
        wordBreak: "break-word", // Asegura que las palabras largas se corten si es necesario
      }
    },
    { 
      name: "access_levels",
      width: `220px`,
      header: {
        dataType: "string",
        placeholder: "Permisos",
        textAlign: "center",
      },
      style: {
        textAlign: "center",       // Alinea el texto a la izquierda
        overflow: "hidden",      // Oculta cualquier desbordamiento fuera de la celda
        textOverflow: "clip",    // Desactiva los tres puntos (opcional)
        whiteSpace: "normal",    // Permite que el texto se ajuste en varias líneas
        wordBreak: "break-word", // Asegura que las palabras largas se corten si es necesario
      }
    },
  ];

  return (
    <MainLayout isLoading={isLoading} setIsLoading={setIsLoading}>
      <div id="users-view-content">
        <MaintenanceView 
          primaryKey={"id"}
          primaryNameKey={"name"}
          menuConfig={{}}
          gridConfig={{ 
            filters, 
            sorters, 
            columns,
            title: "Llista d'<b>USUARIS</b>",
          }}
          reducerName="usersReducer"
          itemNameSingular={"Usuari"}
          actions={usersActions} 
          setIsLoading={setIsLoading}
          setRefreshData={setRefreshData}
          refreshData={refreshData}   
          isMultiRowSelection={true}
          page={page} 
        />
      </div>
    </MainLayout>
  );
};

export default UsersView;
